<app-modal
  [(open)]="open"
  title="Assign to Device"
  [subtitle]="'Group: ' + group.groupId"
  size="medium"
  (closed)="onClose()">

  <div class="border border-hairline rounded-card overflow-hidden mb-4">
    <div class="max-h-64 overflow-y-auto">
      @if (devices().length === 0) {
        <p class="text-center text-ink-3 py-6 text-sm">No devices found.</p>
      }
      @for (device of devices(); track device.clientId) {
        <div
          (click)="selectDevice(device)"
          [class]="selectedDevice()?.clientId === device.clientId
            ? 'flex items-center justify-between px-4 py-3 cursor-pointer bg-sunken border-l-4 border-link'
            : 'flex items-center justify-between px-4 py-3 cursor-pointer hover:bg-sunken border-l-4 border-transparent'">
          <div>
            <p class="text-sm font-medium text-ink-1">{{ device.clientId }}</p>
            <p class="text-xs text-ink-3">{{ device.type }}</p>
          </div>
          <span [class]="device.isProvisioned
            ? 'text-xs px-2 py-0.5 rounded-pill bg-sunken text-link'
            : 'text-xs px-2 py-0.5 rounded-pill bg-sunken text-ink-3'">
            {{ device.isProvisioned ? 'Provisioned' : 'Unprovisioned' }}
          </span>
        </div>
      }
    </div>
  </div>

  @if (selectedDevice()) {
    <div class="bg-sunken rounded-card p-4">
      <p class="text-sm font-medium text-ink-1 mb-3">Actions for <span class="font-bold">{{ selectedDevice()!.clientId }}</span></p>
      <div class="flex flex-wrap gap-2">
        <button (click)="assign()" [disabled]="isLoading()"
          class="rounded-control bg-action px-3 py-2 text-sm font-semibold text-action-text hover:opacity-90 disabled:opacity-40 disabled:cursor-not-allowed">
          Assign Layout Group
        </button>
        <button (click)="sendAllTemplateGroups()" [disabled]="isLoading()"
          class="rounded-control border border-hairline bg-card px-3 py-2 text-sm font-semibold text-ink-1 hover:bg-sunken disabled:opacity-40 disabled:cursor-not-allowed">
          Send All Template Groups (MQTT)
        </button>
        <button (click)="sendAllTemplates()" [disabled]="isLoading()"
          class="rounded-control border border-hairline bg-card px-3 py-2 text-sm font-semibold text-ink-1 hover:bg-sunken disabled:opacity-40 disabled:cursor-not-allowed">
          Send All Templates (MQTT)
        </button>
      </div>
    </div>
  }

  <ng-template modalFooter>
    <div class="flex flex-1 items-center justify-end gap-2">
      <button type="button" (click)="onClose()"
        class="rounded-control border border-hairline bg-card px-4 py-2 text-[13px] font-semibold text-ink-1 hover:bg-sunken">
        Close
      </button>
    </div>
  </ng-template>
</app-modal>
